import UserActivityPage from '../components/analytics/userActivity/UserActivityPage';

const UserActivityAnalyticsPage = () => <UserActivityPage />;

export default UserActivityAnalyticsPage;
